var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-91 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m165 0c-90.980469 0-165 74.019531-165 165 0 57.363281 17.578125 82.609375 91.597656 180.417969 51.933594 68.65625 60.210938 80.359375 73.402344 98.027343 17.707031-23.71875 18.851562-25.875 73.476562-98.128906 73.960938-97.734375 91.523438-122.953125 91.523438-180.316406 0-90.980469-74.019531-165-165-165zm0 240c-41.351562 0-75-33.648438-75-75s33.648438-75 75-75 75 33.648438 75 75-33.648438 75-75 75zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m165 512c79.996094 0 165-26.277344 165-75 0-30.316406-32.953125-51.382812-75.363281-63.320312-46.988281 62.191406-55.472657 74.230468-89.636719 120.140624-34.335938-46.136718-42.464844-57.722656-89.640625-120.136718-42.410156 11.9375-75.359375 33.003906-75.359375 63.316406 0 48.722656 85.003906 75 165 75zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dc62d76a970cfe50bca4c1ca8540db5d.svg";
export { ForwardRef as ReactComponent };